import { vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { class: "input-field col l6 s12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Name", -1 /* HOISTED */)
const _hoisted_4 = ["data-error"]
const _hoisted_5 = { class: "input-field col l6 s12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "School/Company Name", -1 /* HOISTED */)
const _hoisted_7 = ["data-error"]
const _hoisted_8 = { class: "input-field col l6 s12" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email", -1 /* HOISTED */)
const _hoisted_10 = ["data-error"]
const _hoisted_11 = { class: "input-field col l6 s12" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Phone Number", -1 /* HOISTED */)
const _hoisted_13 = ["data-error"]
const _hoisted_14 = { class: "input-field col s12" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Subject", -1 /* HOISTED */)
const _hoisted_16 = ["data-error"]
const _hoisted_17 = { class: "input-field col s12" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { for: "message" }, "Message", -1 /* HOISTED */)
const _hoisted_19 = ["data-error"]
const _hoisted_20 = { class: "col s12" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons left" }, "send", -1 /* HOISTED */)
const _hoisted_22 = {
  key: 1,
  class: "row"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "col s12" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Thank you! We'll get back to you as soon as possible.")
], -1 /* HOISTED */)
const _hoisted_24 = [
  _hoisted_23
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.showFrom)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (_ctx.vm.name = $event)),
              name: "name",
              id: "name",
              type: "text",
              class: _normalizeClass(_ctx.v$.name.$errors.length === 0 ? 'valid' : 'invalid')
            }, null, 2 /* CLASS */), [
              [_vModelText, _ctx.vm.name]
            ]),
            _hoisted_3,
            (_ctx.v$.name.$errors.length)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "helper-text",
                  "data-error": _ctx.v$.name.$errors[0].$message
                }, null, 8 /* PROPS */, _hoisted_4))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.vm.schoolOrCompanyName = $event)),
              name: "SchoolOrCompanyName",
              id: "SchoolOrCompanyName",
              type: "text",
              class: _normalizeClass(_ctx.v$.schoolOrCompanyName.$errors.length === 0 ? 'valid' : 'invalid')
            }, null, 2 /* CLASS */), [
              [_vModelText, _ctx.vm.schoolOrCompanyName]
            ]),
            _hoisted_6,
            (_ctx.v$.schoolOrCompanyName.$errors.length)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "helper-text",
                  "data-error": _ctx.v$.schoolOrCompanyName.$errors[0].$message
                }, null, 8 /* PROPS */, _hoisted_7))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.vm.email = $event)),
              name: "email",
              id: "email",
              type: "text",
              class: _normalizeClass(_ctx.v$.email.$errors.length === 0 ? 'valid' : 'invalid')
            }, null, 2 /* CLASS */), [
              [_vModelText, _ctx.vm.email]
            ]),
            _hoisted_9,
            (_ctx.v$.email.$errors.length)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "helper-text",
                  "data-error": _ctx.v$.email.$errors[0].$message
                }, null, 8 /* PROPS */, _hoisted_10))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.vm.phoneNumber = $event)),
              name: "Phone",
              id: "Phone",
              type: "text",
              class: _normalizeClass(_ctx.v$.phoneNumber.$errors.length === 0 ? 'valid' : 'invalid')
            }, null, 2 /* CLASS */), [
              [_vModelText, _ctx.vm.phoneNumber]
            ]),
            _hoisted_12,
            (_ctx.v$.phoneNumber.$errors.length)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "helper-text",
                  "data-error": _ctx.v$.phoneNumber.$errors[0].$message
                }, null, 8 /* PROPS */, _hoisted_13))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (_ctx.vm.subject = $event)),
              name: "subject",
              id: "subject",
              type: "text",
              class: _normalizeClass(_ctx.v$.subject.$errors.length === 0 ? 'valid' : 'invalid')
            }, null, 2 /* CLASS */), [
              [_vModelText, _ctx.vm.subject]
            ]),
            _hoisted_15,
            (_ctx.v$.subject.$errors.length)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "helper-text",
                  "data-error": _ctx.v$.subject.$errors[0].$message
                }, null, 8 /* PROPS */, _hoisted_16))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (_ctx.vm.message = $event)),
              name: "message",
              id: "message",
              class: _normalizeClass(["materialize-textarea", _ctx.v$.message.$errors.length === 0 ? 'valid' : 'invalid'])
            }, null, 2 /* CLASS */), [
              [_vModelText, _ctx.vm.message]
            ]),
            _hoisted_18,
            (_ctx.v$.message.$errors.length)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "helper-text",
                  "data-error": _ctx.v$.message.$errors[0].$message
                }, null, 8 /* PROPS */, _hoisted_19))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("a", {
              class: "waves-effect waves-light btn",
              onClick: _cache[6] || (_cache[6] = $event => (_ctx.submitForm()))
            }, [
              _hoisted_21,
              _createTextVNode(_toDisplayString(_ctx.subscribeButtonText), 1 /* TEXT */)
            ]),
            _createCommentVNode(" @Html.GoogleInvisibleReCaptcha(\"Submit form\", Configuration.GetValue<String>(\"GoogleReCaptcha:ClientKey\"), \"submitForm\") ")
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.showConfirmation)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24))
      : _createCommentVNode("v-if", true)
  ]))
}